import React from 'react';
import { VoucherFormSection } from '../../Section';
import AllowedCustomerRuleEditor from './AllowedCustomerRuleEditor';

const VoucherFormCustomer: React.FC = () => {
  const isEnabled = localStorage.getItem('enable-allowed-customer-rule') === 'true';

  if (!isEnabled) {
    return null;
  }

  return (
    <VoucherFormSection
      title='Customer'
      subtitle='Restrict the voucher to a specific customer.'
      inputs={<AllowedCustomerRuleEditor />}
    />
  );
};

export default VoucherFormCustomer;
